export enum ReportType {
	ScenarioTester,
	ModelsBrowse,
	PortfolioAnalyser,
	PortfolioAnalysisConstruction,
	PortfolioCentre,
	InvestmentQuality
}

export const LANDSCAPE_REPORT_TYPES: ReportType[] = [ReportType.ScenarioTester, ReportType.ModelsBrowse, ReportType.InvestmentQuality];

// for US products
export const DEFAULT_DISCLOSURE_TEXT_CLASSES: string[] = ['text-condensed-light'];

// due to MIFID related L&C requirements we need regular font disclaimers for EMEA products
export const NILE_DISCLOSURE_TEXT_CLASSES = ['text-regular', 'text-10'];

export const PDF_CUSTOM_PAGE_DIMENSIONS = {
	width: '612px',
	height: '792px'
};

export const DEFAULT_PERFORMANCE_DISCLOSURE_TEXT_CLASSES: string[] = ['text-condensed-light', 'text-8'];

export const DEFAULT_GROSS_PERFORMANCE_DISCLOSURE = `<b>Past performance is not a guarantee of future results.</b>
Performance shown is of a hypothetical investment and does not represent an actual portfolio or investment product.
Each portfolio represents an allocation to the underlying constituent securities. The underlying constituent performance is based on actual historical performance.
The performance assumes reinvestment of dividends and capital gains. Fund expenses, including management fees and other expenses were deducted,
but performance does not include the deduction of any overlay fees that a financial advisor may charge.
If a BlackRock Model Portfolio is included in this analysis, the inception date for the BlackRock Model Portfolio is shown above.
Performance of the BlackRock Model Portfolio(s) reflects rebalancing of such portfolio(s) in response to market conditions.
The inception date for any other portfolio(s) is the inception date of the portfolio constituent that was incepted latest.
In addition, performance for any other portfolio(s)assumes that the constituents were held in weights detailed by
the Portfolio Composition section since inception and rebalanced quarterly.
However, it does not reflect changes made in response to market conditions.
The portfolio(s) would have performed differently if trading in response to market conditions were taken into account.
However, it is impossible to determine how the portfolio(s) would have been traded.
Performance of an actual portfolio may differ significantly from the hypothetical performance shown for a variety of reasons,
including but not limited to differences in market conditions, client-imposed investment restrictions, the timing of client investments and withdrawals,
fees payable, and/or other factors. Source: BlackRock for the BlackRock Model Portfolios and Morningstar for any other portfolio(s).`;
